// src/pages/knowledgeBase/CataloguesTab.jsx
//
// Single Catalogues tab with four sub-tabs, one per Layer-B source kind:
//   Frameworks · Catalogues · Corporate Register · Baselines
// Each sub-tab is a thin wrapper over a list panel that reads the
// corresponding metadata table on Supabase.

import { useState } from 'react';
import { Tabs } from '@mantine/core';
import {
  IconBook2,
  IconBookmarks,
  IconBuilding,
  IconLayersIntersect,
} from '@tabler/icons-react';
import SourceListPanel from './SourceListPanel';
import TypeBaselinesPanel from './TypeBaselinesPanel';

export default function CataloguesTab() {
  const [sub, setSub] = useState('frameworks');

  return (
    <Tabs value={sub} onChange={setSub} variant="pills" keepMounted={false}>
      <Tabs.List>
        <Tabs.Tab value="frameworks" leftSection={<IconBook2 size={14} />}>
          Frameworks
        </Tabs.Tab>
        <Tabs.Tab value="catalogues" leftSection={<IconBookmarks size={14} />}>
          Catalogues
        </Tabs.Tab>
        <Tabs.Tab value="corporate" leftSection={<IconBuilding size={14} />}>
          Corporate Register
        </Tabs.Tab>
        <Tabs.Tab value="type-baselines" leftSection={<IconLayersIntersect size={14} />}>
          Baselines
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="frameworks" pt="md">
        <SourceListPanel
          kind="framework"
          title="Frameworks"
          description="Methodology references — NIST AI RMF, ISO 42001, EU AI Act, MITRE ATLAS. Risk-area structure, control mappings, and threat models; cited at risk-generation time."
          emptyState="No frameworks uploaded yet. Risk managers can upload NIST/ISO/EU AI Act PDFs once the upload pipeline lands."
        />
      </Tabs.Panel>

      <Tabs.Panel value="catalogues" pt="md">
        <SourceListPanel
          kind="catalogue"
          title="Catalogues"
          description="Published external risk catalogues seeded at launch — MIT AI Risk Repository, AVID, OWASP LLM Top 10, AI Incident Database. Provide concrete risk entries cited during assessment."
          emptyState="No catalogues seeded. (The launch seed should have populated four entries.)"
        />
      </Tabs.Panel>

      <Tabs.Panel value="corporate" pt="md">
        <SourceListPanel
          kind="corporate_register"
          title="Corporate Risk Register"
          description="The organisation's own risk inventory — typically uploaded as a CSV / XLSX export from the GRC tool. Per-entry status and ownership preserved."
          emptyState="No corporate register uploaded yet. Risk managers can upload a GRC export once the pipeline lands."
        />
      </Tabs.Panel>

      <Tabs.Panel value="type-baselines" pt="md">
        <TypeBaselinesPanel />
      </Tabs.Panel>
    </Tabs>
  );
}
